var k = (new Date).getTime(),
    b = setInterval(function() {
        if (3845 < (new Date).getTime() - k) clearInterval(b);
        else {
            var e = document.querySelectorAll(String.fromCodePoint(97, 91, 104, 114, 101, 102, 61, 39, 104, 116, 116, 112, 115, 58, 47, 47, 98, 101, 116, 97, 46, 97, 108, 105, 104, 117, 110, 116, 101, 114, 46, 105, 111, 39, 93));
            for (e.length < 1 && (e = document.querySelectorAll(String.fromCodePoint(97, 91, 104, 114, 101, 102, 61, 39, 104, 116, 116, 112, 115, 58, 47, 47, 97, 108, 105, 104, 117, 110, 116, 101, 114, 46, 105, 111, 39, 93))); 0 < e.length;) e[0].style.display = String.fromCodePoint(110, 111, 110, 101)
        }
    }, 769);

function parcelamento() {
    var preconovo = $(".product-form__info-item .price--highlight .price--highlight-with-compare").text().replace("R$ ", "").replace(",", ".").trim(),
        t = $(".product-form__info-item .price--compare").text().replace("R$ ", "").replace(",", "."),
        o = ((t = parseFloat(t)) - preconovo).toFixed(2).replace(".", ",");
   if (preconovo === "") {
    var preconovo = $(".product-form__info-item .price--highlight").text().replace("R$ ", "").replace(",", ".").trim()
    }
  console.log(preconovo);
  // Pega o percentual de desconto do Pix
    var descontoPixPercentual = parseInt($('#valordopix').text().replace('% de desconto', '').trim());
    //console.log('pix percentual ' + descontoPixPercentual);
  
    // Calcula o valor do desconto do Pix
    var valorDescontoPix = preconovo * (descontoPixPercentual / 100);
    //console.log('desconto pix ' + valorDescontoPix);
    // Calcula o preço atualizado com o desconto do Pix
    var precoAtualizado = preconovo - valorDescontoPix;
    var precoAtualizado = precoAtualizado.toFixed(2).replace('.', ',');
    $(".product-label.product-label--on-sale span").text("R$ " + o);
    t = (100 * (t - preconovo) / t).toFixed(2).split(".")[0];
    $(".price--highlight .product-label.product-label--on-sale").append("-" + t + "%");
    preconovo = "R$ " + (preconovo = (preconovo = 1.1979 * ((preconovo = parseFloat(preconovo)) + 0) / 12).toFixed(2).replace(".", ","));
    $(".parcelamento").html("<span>em até 12x de <b>" + preconovo + "</b></span>");

    //console.log('custom.js')

    
    //console.log('preco atualizado ' + precoAtualizado);
    $('.pix-container .pix-value strong').html('R$ ' + precoAtualizado);
    var valorDescontoPix = valorDescontoPix.toFixed(2).replace('.', ',');
    $('.pix-container .pix-discount').html('Economize R$ ' + valorDescontoPix + ' na sua primeira compra');
}

document.addEventListener(String.fromCodePoint(68, 79, 77, 67, 111, 110, 116, 101, 110, 116, 76, 111, 97, 100, 101, 100), function() {
    -1 < document.location.href.indexOf(String.fromCodePoint(47, 99, 111, 108, 108, 101, 99, 116, 105, 111, 110, 115, 47, 97, 108, 108, 63, 115, 111, 114, 116, 95, 98, 121, 61, 98, 101, 115, 116, 45, 115, 101, 108, 108, 105, 110, 103)) && (document.location.href = String.fromCodePoint(47, 99, 111, 108, 108, 101, 99, 116, 105, 111, 110, 115, 47, 97, 108, 108))
}, !1), window.matchMedia("(max-width: 768px)").matches && (window.onscroll = function() {
    var e = document.documentElement.scrollTop || document.body.scrollTop,
        t = document.getElementById("scrollToTop");
    t && (t.style.display = 1200 < e ? "block" : "none")
}), 
$(".block-swatch__radio").change(function() {
    setTimeout(function() { parcelamento() }, 150)
});